import React, { useState } from "react"

import PropTypes from "prop-types"

import "./index.less"
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import CustomTooltip from "./components/CustomTooltip"

const toPercent = (decimal, isCalculationTopTwoBox) => {
  return isCalculationTopTwoBox ? `${decimal.toFixed(0)}%` : decimal
}

export function EvolutionLineChart(props) {
  const [lineActive, setLineActive] = useState(null)

  const { isCalculationTopTwoBox } = props
  const YAxisRange = isCalculationTopTwoBox ? [0, 100] : [0, 5]

  return (
    <ResponsiveContainer>
      <LineChart
        data={props.data}
        margin={{
          top: 28,
          right: 0,
          bottom: 0,
          left: 0,
        }}>
        <CartesianGrid vertical={false} stroke="#EDE9E9" />
        <XAxis
          dataKey="period"
          tickLine={false}
          axisLine={false}
          tickMargin={10}
          height={30}
          domain={[0, 100]}
          padding={{ left: 40, right: 40 }}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tickCount={6}
          type="number"
          tick={{ fill: "#8D8A8D", fontSize: "12" }}
          domain={YAxisRange}
          tickFormatter={(item) => toPercent(item, isCalculationTopTwoBox)}
        />
        <Tooltip
          content={(element) => (
            <CustomTooltip element={element} lineActive={lineActive} />
          )}
          cursor={{ fill: "transparent" }}
        />
        <Legend
          verticalAlign="top"
          wrapperStyle={{ top: 0, left: "10%" }}
          width="80%"
          align="center"
        />
        {props.lines.map((item, index) => {
          return (
            <Line
              key={index}
              type={item.type}
              dataKey={item.dataKey}
              stroke={item.stroke}
              name={item.name}
              connectNulls
              fill={item.stroke}
              dot={{ stroke: item.stroke }}
              activeDot={{
                r: 5,
                stroke: item.stroke,
                onMouseOver: (e) => setLineActive({ dataKey: item.dataKey }),
                onMouseLeave: (e) => setLineActive({ dataKey: item.dataKey }),
              }}
            />
          )
        })}
      </LineChart>
    </ResponsiveContainer>
  )
}

EvolutionLineChart.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  lines: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
}
export default EvolutionLineChart
